import he from 'he';
import $ from 'jquery';
import cssService from 'Modules/css';

function ElementsHighliter(highliterService) {
  this.highliterService = highliterService;
}

ElementsHighliter.prototype.colorizeElement = function (elements, force) {
  var promises = prepareElements(elements, this.highliterService, force);

  return $.when.apply(null, promises).done(
    function () {
      renderCodeBlocks(elements, this.highliterService.name);
    }.bind(this)
  );
};

ElementsHighliter.prototype.unColorizeElement = function (elements) {
  var $elements = $(elements),
    code;
  $elements.each(
    function (n, element) {
      try {
        code = getNormalizedElementCode(element);

        $(element)
          .text(code.source)
          .removeAttr('data-code')
          .removeAttr('class')
          .removeClass(this.highliterService.name);
      } catch (e) {
        //
      }
    }.bind(this)
  );
};

ElementsHighliter.prototype.getCodeFromElement = function (element) {
  return getNormalizedElementCode($(element));
};

ElementsHighliter.prototype.updateColorizedElement = function (element, code) {
  setElementCode(element, code);
  return this.colorizeElement(element, true);
};

function prepareElements(elements, highliter, force) {
  var promises = [],
    $codeElements = $(elements),
    cssInjected = false;

  $codeElements.each(function (n, element) {
    var $element = $(element),
      code,
      colorized;

    if ($element.attr('data-code') && !force) {
      return;
    }

    code = getNormalizedElementCode(element);
    colorized = highliter
      .colorize(code.source, code.language)
      .done(function (colorizedCode, colorizedCssRules) {
        $element.data('colorizedCode', colorizedCode);

        if (!cssInjected) {
          cssService.injectCss(colorizedCssRules, element.ownerDocument);
          cssInjected = true;
        }
      });

    promises.push(colorized);
  });

  return promises;
}

function setElementCode(element, code) {
  code.source = he.encode(code.source);
  $(element).attr('data-code', JSON.stringify(code));
}

function getNormalizedElementCode(element) {
  var $element = $(element),
    codeString = $element.attr('data-code'),
    code;

  if (!codeString) {
    code = {
      language: $element.attr('data-claire-semantic'),
      source: $element.text(),
    };

    setElementCode($element, code);
  } else {
    code = JSON.parse(codeString);
  }

  code.source = he.decode(code.source);

  return code;
}

function renderCodeBlocks(codeElements, classname) {
  $(codeElements).each(function (n, element) {
    var $element = $(element);

    $element.html($element.data('colorizedCode')).addClass(classname);
  });
}

export default ElementsHighliter;
